import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { StoryLovedFragment } from 'graphql/generated/graphql';

export interface PlaylistState {
  isAddStoryToPlaylistOpen?: boolean;
  isPlaylistCreationOpen: boolean;
  name?: string;
  numberOfCurrentPlaylists: number;
  playlistImageId?: string;
  storyIdToBeAdded?: StoryLovedFragment;
}

export const initialPlaylistState: PlaylistState = {
  isAddStoryToPlaylistOpen: false,
  isPlaylistCreationOpen: false,
  numberOfCurrentPlaylists: 0,
};

export const playlistSlice = createSlice({
  name: 'playlist',
  initialState: initialPlaylistState,
  reducers: {
    closeAddStoryToPlaylist: (state) => {
      state.isAddStoryToPlaylistOpen = false;
    },
    closePlaylistCreation: (state) => {
      state.isPlaylistCreationOpen = false;
      state.numberOfCurrentPlaylists = 0;
      state.name = undefined;
    },
    openAddStoryToPlaylist: (
      state,
      action: PayloadAction<StoryLovedFragment>,
    ) => {
      state.isAddStoryToPlaylistOpen = true;
      state.storyIdToBeAdded = action.payload;
    },
    openPlaylistCreation: (state, action: PayloadAction<number>) => {
      state.isPlaylistCreationOpen = true;
      state.numberOfCurrentPlaylists = action.payload;
    },
    setName: (state, action: PayloadAction<string>) => {
      state.name = action.payload;
    },
    setPlaylistImageId: (state, action: PayloadAction<string>) => {
      state.playlistImageId = action.payload;
    },
  },
});

export const getPlaylistname = ({ playlist }: { playlist: PlaylistState }) =>
  playlist.name;

export const getStoryIdToBeAdded = ({
  playlist,
}: {
  playlist: PlaylistState;
}) => playlist.storyIdToBeAdded;

export const getPlalistImageId = ({ playlist }: { playlist: PlaylistState }) =>
  playlist.playlistImageId;

export const getIsPlaylistCreationOpen = ({
  playlist,
}: {
  playlist: PlaylistState;
}) => playlist.isPlaylistCreationOpen;

export const getIsAddStoryToPlaylistOpen = ({
  playlist,
}: {
  playlist: PlaylistState;
}) => playlist.isAddStoryToPlaylistOpen;

export const getNumberOfCurrentPlaylists = ({
  playlist,
}: {
  playlist: PlaylistState;
}) => playlist.numberOfCurrentPlaylists;

export const {
  closeAddStoryToPlaylist,
  closePlaylistCreation,
  openAddStoryToPlaylist,
  openPlaylistCreation,
  setName,
  setPlaylistImageId,
} = playlistSlice.actions;

export default playlistSlice.reducer;
